import React from 'react';
import { useNivelAcesso } from '../hooks/useNivelAcesso';
import { useTheme } from '../contexts/ThemeContext';

const UserBadge = ({ nivel = null, showLabel = true }) => {
  const { user, getNivelLabel, getNivelBadgeColor } = useNivelAcesso();
  const { darkMode } = useTheme();
  
  const nivelToShow = nivel || user?.nivel_acesso;
  if (!nivelToShow) return null;

  return (
    <span className={`px-2 py-1 text-xs font-semibold rounded-full ${getNivelBadgeColor(nivelToShow, darkMode)}`}>
      {showLabel ? getNivelLabel(nivelToShow) : nivelToShow.toUpperCase()}
    </span>
  );
};

export default UserBadge;